import I5Detail from './I5Detail';

export default I5Detail;
